export default __webpack_public_path__ + "static/media/drawcord.e5f796f9.jpg";